import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import reception from '../../../assets/reception.png';
import consultation from '../../../assets/consultaion.png';
import email from '../../../assets/email.png';
import walkin from '../../../assets/walkin.svg';
import whatsapp from '../../../assets/whatsapp.svg';

const ContactUs = () => {
  const contactItems = [
    {
      img: reception,
      title: 'Reception',
      description: 'Get in touch with our dedicated team to explore customized solutions tailored to your needs',
      link: 'https://demo.winmigrationgroup.com/ContactUs',
      linkText: 'Contact Us',
    },
    {
      img: consultation,
      title: 'Schedule a Consultation',
      description: 'Book a 30-minute Zoom session with one of our experienced Migration Agents to get expert advice tailored to your needs.',
      link: 'https://visa-winmigrationgroup.zohobookings.com.au/#/winmigrationgroup',
      linkText: 'Schedule a Consultation',
    },
    {
      img: walkin,
      title: 'Walk-In Consultation',
      description: 'Visit us in person for a face-to-face consultation with our expert Migration Agent to receive personalized advice and guidance tailored to your migration journey.',
      link: 'https://visa-winmigrationgroup.zohobookings.com.au/#/winmigrationgroup',
      linkText: 'Walk-In Consultation',
    },
    {
      img: email,
      title: 'Email us',
      description: 'Reach out to us via email—we’re here to answer your questions and provide support.',
      link: 'mailto:contact@winmigrationgroup.com',
      linkText: 'Send an Email',
    },
    {
      img: whatsapp,
      title: 'Message Us on WhatsApp',
      description: 'Connect with us instantly on WhatsApp for quick assistance and answers to your queries.',
      link: 'https://wa.me/61423439693?text=I%20want%20to%20know%20about%20your%20services',
      linkText: 'WhatsApp',
    },
  ];

  return (
    <section className="section color-bottom">
      <div className="container">
        <div className="max-w more">
          <div data-w-id="166d813f-4ff4-c949-5b3d-e38231847ba1" className="flex-tag">
            <div className="bullet-tag "></div>
            <h2 className="main-title white">Contact us</h2>
          </div>
          <p
            data-w-id="166d813f-4ff4-c949-5b3d-e38231847ba5"
            className="subhead-main for-title white"
          >
            Seeking a different solution?{' '}
            <span className="gray-text-color">Engage with us via email or telephone.</span>
          </p>
        </div>
        <div className="margin-20px">
          <Swiper
            spaceBetween={15}
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Autoplay]}
            loop={true}
          >
            {contactItems.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="cta-block">
                  <div>
                    <img src={item.img} loading="lazy" width="60" alt={item.title} />
                  </div>
                  <div className="margin-30px">
                    <h3 className="step-title">{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                  <div className="margin-15px">
                    <a href={item.link} className="button-underline w-inline-block">
                      <div className="button-color">{item.linkText}</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
